"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverContainerOpenIcon = exports.PopoverContainerTitleStyle = exports.PopoverContainerCloseIcon = exports.PopoverContainerContentStyle = exports.PopoverContainerHeaderStyle = exports.PopoverContainerIcon = exports.PopoverContainerWrapperStyle = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _themes = require("../../style/themes");

var _iconButton = _interopRequireDefault(require("../icon-button"));

var _icon = _interopRequireDefault(require("../icon/icon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PopoverContainerWrapperStyle = _styledComponents.default.div`
  position: relative;
  display: inline-block;
`;
exports.PopoverContainerWrapperStyle = PopoverContainerWrapperStyle;
const PopoverContainerIcon = (0, _styledComponents.default)(_iconButton.default)`
  ${_icon.default} {
    color: ${({
  theme
}) => theme.popoverContainer.iconColor};
  } ;
`;
exports.PopoverContainerIcon = PopoverContainerIcon;
const PopoverContainerHeaderStyle = _styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  max-width: 280px;
`;
exports.PopoverContainerHeaderStyle = PopoverContainerHeaderStyle;
const PopoverContainerContentStyle = _styledComponents.default.div`
  ${_styledSystem.padding}

  background: ${({
  theme
}) => theme.colors.white};
  box-shadow: ${({
  theme
}) => theme.shadows.depth1};
  min-width: 300px;
  position: absolute;
  z-index: ${({
  theme
}) => theme.zIndex.popover};

  ${({
  shouldCoverButton
}) => shouldCoverButton && "top: 0"}

  ${({
  position
}) => position === "left" ? "right: 0" : "left: 0"};

  ${({
  animationState
}) => {
  switch (animationState) {
    case "entering":
      return `
        opacity: 0;
        transform: translateY(-8px);
      `;

    case "entered":
      return `
        opacity: 1; 
        transform: translateY(0);
        transition: all 0.3s cubic-bezier(0.25, 0.25, 0, 1.5);
          `;

    case "exiting":
      return `
        opacity: 0; 
        transform: translateY(-8px);
        transition: all 0.3s cubic-bezier(0.25, 0.25, 0, 1.5);
          `;

    default:
      return "opacity: 0";
  }
}}
`;
exports.PopoverContainerContentStyle = PopoverContainerContentStyle;
const PopoverContainerOpenIcon = (0, _styledComponents.default)(_iconButton.default)`
  ${_icon.default} {
    color: ${({
  theme
}) => theme.popoverContainer.iconColor};
  }
`;
exports.PopoverContainerOpenIcon = PopoverContainerOpenIcon;
const PopoverContainerCloseIcon = (0, _styledComponents.default)(_iconButton.default)`
  position: absolute;
  top: 16px;
  right: 24px;

  ${_icon.default} {
    color: ${({
  theme
}) => theme.popoverContainer.iconColor};
  } ;
`;
exports.PopoverContainerCloseIcon = PopoverContainerCloseIcon;
const PopoverContainerTitleStyle = _styledComponents.default.div`
  font-size: 16px;
  font-weight: bold;
`;
exports.PopoverContainerTitleStyle = PopoverContainerTitleStyle;
PopoverContainerContentStyle.defaultProps = {
  theme: _themes.baseTheme
};
PopoverContainerIcon.defaultProps = {
  theme: _themes.baseTheme
};
PopoverContainerCloseIcon.defaultProps = {
  theme: _themes.baseTheme
};
PopoverContainerOpenIcon.defaultProps = {
  theme: _themes.baseTheme
};